import styled from 'styled-components';
import { colors } from 'global/colors';

export const ButtonContainer = styled.div.attrs({ className: 'col-sm-6' })`
  display: flex;
  justify-content: flex-end;
`;

export const ChallengeButton = styled.button.attrs({ className: 'btn mb-3' })`
  background-color: ${colors.darkBlue};
  color: white;
  font-weight: 400;
  &:hover {
    color: white;
  }
`;

export const CMSContainer = styled.div.attrs({ className: 'container-fluid custom-container' })``;
export const ContainerBody = styled.div.attrs({ className: 'row mb-1' })``;
export const Header = styled.div.attrs({ className: 'row pb-1' })``;
export const HeadingContainer = styled.div.attrs({ className: 'col-sm-6' })``;

export const Heading = styled.span`
  color: ${colors.darkBlue};
  font-family: 'Open Sans', sans-serif;
  font-size: 2rem;
`;
